import React from 'react';
import { saveTransaction, uploadInvoice } from '../../services/memberApiServices';
import '../styles/MemberBilling.css';
import { useCart } from './CartContext.js';
import PayNow from '../../components/class/payNow';
import { useAnalytics } from '../../hooks/useAnalytics';


function MemberDuepayment({ groupd, trans, mem, SuccessCallback }) {
    const {
        getGymId,
    } = useCart();
    const { trackButtonClick } = useAnalytics();
    const formatCartData = (payinfo) => {

        let tId = trans ? trans.tId : 0;
        let balanceamt = trans ? trans.payment.balance : 0;
        let totalPrice = trans ? trans.payment.totalamount : 0;
        let selItems = groupd.map((item) => {
            let membership = item.plan.length > 0 ? item.plan[0] : (item.addons.length > 0 ? item.addons[0] : [])
            const taxIncluded = membership.taxcheck === true ? "Included" : "Excluded"
            // const taxamounts = item.payment.taxamounts ? item.payment.taxamounts : [{ TaxCheck: `${taxIncluded}` }];
            const taxamounts = item.payment.taxamounts ? item.payment.taxamounts : [{ TaxCheck: taxIncluded }];
            return {
                Item: membership,
                idate: item.startdate,
                isplan: 3,
                members: mem.filter((meme) => meme.itemid === item.itemid).map((obj) => obj.members).flat(),
                quantity: item.quantity,
                taxamounts: taxamounts,
                token: trans.token,
                _id: item.itemid,
                price: balanceamt,
                ref_tId: tId,
            };
        });
        console.log(selItems, 'selItems');
        const items = selItems

        return {
            items,
            paymentData: {
                PaymentLinkId: -1,
                balance: 0,
                parentname: trans.parentname ? trans.parentname : {},
                payinfo: {
                    mode: -3,
                    balmode: 1,
                    info: {
                        cash_amt: '',
                        cc_amt: '',
                        upi_amt: '',
                        upi_input: '',
                        wallet_amt: ''
                    },
                    balance: 0,
                    razorpay: payinfo && payinfo !== null ? payinfo : {}
                },
                price: trans?.payment?.balance,
                tId: tId,
                ref_tId: tId,
                token: trans ? trans.token : -1,
                totalPrice: trans?.payment?.totalamount,
                transDate: trans?.createdAt,
                razorpay: payinfo && payinfo !== null ? payinfo : {},
                transId: '',
                type: 2
            }
        };
    };

    const handleSubmit = async (payinfo) => {

        const formattedData = formatCartData(payinfo);
        console.log('Data to send to backend:', formattedData);
        const update = {
            ...formattedData.items,
            ...formattedData.paymentData
        }
        console.log(update, "update");

        try {
            const saverep = await saveTransaction(
                { ...update, sId: getGymId(), tId: trans ? trans.tId : 0, gymid: getGymId() },
                getGymId(),
            );
            if (!saverep || !saverep.ok) {
                console.error("Invalid or failed response.");
                return;
            }
            const result = await saverep.json();
            console.log("saveTransaction999", result);

            if (!saverep || result === false) {
                return;
            }

            if (result?.message === "Transaction was already created") {

                return;
            }
            await trackButtonClick("MemberDuepayment", "Update_Membership_Transaction", "member", {});
            const uploadsaverep = await uploadInvoice(
                { invoiceId: trans ? trans.tId : 0, Gid: getGymId(), url: window.location.origin },
                trans ? trans.tId : 0,
            );
            if (!uploadsaverep || uploadsaverep === false) {
                return;
            }
            const url = await uploadsaverep.json()
            console.log(url, 'url');

            SuccessCallback()

        } catch (e) {
            console.log("Errore::::::::::::::::: " + e);

        }
    };


    const callbackfunction = async (data) => {
        await handleSubmit(data)
    }

    const processing = (data) => {
    }
    const userdetails = {
        name: trans?.parentname?.name,
        email: trans?.parentname?.email,
        contact: trans?.parentname?.number
    }


    return (
        <>

            <PayNow
                amount={trans?.payment?.balance}
                callback={callbackfunction}
                gymid={getGymId()}
                processing={processing}
                user={userdetails}
                from="Membership"
                title={"Proceed to Payment"}
            />
        </>

    )
}

export default MemberDuepayment
